export const AdjustmentsDefined: React.FC = () => {
  return (
    <div
      style={{
        display: 'flex',
        color: '#FFFFFF',
        background: '#BC0000',
        borderRadius: '4px',
        alignItems: 'center',
        marginLeft: '10px',
      }}
    >
      <div
        style={{
          width: '18px',
          height: '18px',
          fontFamily: 'Inter',
          fontStyle: 'normal',
          fontWeight: '500',
          fontSize: '11px',
          lineHeight: '18px',
          border: '1px solid #FFFFFF',
          borderRadius: '50%',
          textAlign: 'center',
          margin: '9px',
        }}
      >
        D
      </div>
      <div
        style={{
          fontFamily: 'Roboto',
          fontStyle: 'normal',
          fontWeight: '400',
          fontSize: '12px',
          letterSpacing: '0.15px',
          margin: '9px 19px 9px 4px',
        }}
      >
        Dostosowane zasady oceniania
      </div>
    </div>
  );
};
